import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from 'react-autocomplete'
import { cloneDeep, sortBy, uniqBy } from 'lodash'

import { getAllProductsAtQuays, getMatchingProducts } from '../../../utils/general'
import '../SearchField.scss'

export default class CargoSearchField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    productName: PropTypes.string,
    operation: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool.isRequired,
    error: PropTypes.string,
    quays: PropTypes.array.isRequired,
    readOnly: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      searchCargoInput: props.productName || '',
      cargoSearchResults: props.productName ? this.findMatchingProducts(props.productName, props.operation) : []
    }
  }

  render() {
    return (
      <div className="group">
        <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor="cargo-autocomplete">
          {this.props.name}
          {this.props.required ? ' *' : null}
        </label>
        <div className="input-wrapper">
          <Autocomplete
            wrapperStyle={{ display: 'block' }}
            value={this.state.searchCargoInput}
            inputProps={{
              disabled: this.props.readOnly === true,
              name: this.props.name,
              id: 'cargo-autocomplete',
              className: `input-field ${this.props.error ? 'error' : ''}`
            }}
            items={this.state.cargoSearchResults}
            getItemValue={item => item.name}
            onSelect={this.onCargoSearchResultSelected}
            onChange={this.onSearchCargoInputChange}
            renderItem={this.renderCargoSearchResultsListItem}
            renderMenu={this.renderSearchResultsList}
          />
        </div>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  /**
   * When user selects cargo from cargo search results
   */
  onCargoSearchResultSelected = (product, productObject) => {
    if (!productObject.productGroup || !productObject.product) {
      return
    }

    this.setState({ searchCargoInput: product ? product : '' })
    this.props.onChange(productObject)
  }

  /**
   * Handle change of the cargo search input
   * @param event
   * @param input
   */
  onSearchCargoInputChange = (event, input) => {
    this.setState({ searchCargoInput: input, loading: true })

    const operation = this.props.operation

    // Fetch search results based on input query
    if (input && input.length >= 1) {
      const normalisedResults = this.findMatchingProducts(input, operation)
      this.setState({ cargoSearchResults: normalisedResults, loading: false })
    } else {
      const cargo = Object.assign({ product: null, productGroup: null })
      this.props.onChange(cargo)
    }
  }

  findMatchingProducts = (searchTerm, operation) => {
    const allProducts = getAllProductsAtQuays(this.props.quays)
    const result = getMatchingProducts(searchTerm, operation, allProducts, true)
    const uniqueResults = uniqBy(result, 'product')
    const sortedResults = sortBy(uniqueResults, 'product')
    return this.normaliseSearchResults(sortedResults, 'product')
  }

  /**
   * Remove special characters from searchresults
   * @param searchResults
   * @param fieldname
   */
  normaliseSearchResults = (searchResults, fieldname) => {
    return searchResults.map(searchResult => {
      const formattedSearchResult = cloneDeep(searchResult)
      formattedSearchResult.name = searchResult[fieldname]
      return formattedSearchResult
    })
  }

  /**
   * Render cargo search result list
   * @param items
   * @param value
   */
  renderSearchResultsList = (items, value) => {
    return (
      <div className={'search-result-menu'}>
        {value === '' ? (
          <div style={{ padding: 6 }}>Search by product name</div>
        ) : this.state.loading ? (
          <div style={{ padding: 6 }}>Loading...</div>
        ) : items.length === 0 ? (
          <div style={{ padding: 6 }}>No matches for {value}</div>
        ) : (
          this.renderSearchResultsListCategoryHeader(items)
        )}
      </div>
    )
  }

  /**
   * Render category headers in ship search results list
   * @param items
   */
  renderSearchResultsListCategoryHeader(items) {
    return items.map((item, index) => {
      const text = item.props['data-cargo-name']
      if (index === 0 || items[index - 1].props['data-cargo-name'].charAt(0) !== text.charAt(0)) {
        return [
          <div key={index} className="item-category-header">
            {text.charAt(0)}
          </div>,
          item
        ]
      } else {
        return item
      }
    })
  }

  /**
   * Render cargo search result list item
   * @param item
   * @param isHighlighted
   */
  renderCargoSearchResultsListItem = (item, isHighlighted) => {
    const highLightedClassName = isHighlighted ? 'item highlighted' : 'item'

    return (
      <div
        className={highLightedClassName}
        key={item.name + '_' + item.productGroup + '_' + item.loadSpeed}
        data-cargo-name={item.name}
        id={item.name}
      >
        <div className="row name">
          <span className="label" />
          <span className="value">{item.name}</span>
        </div>
        <div className="row">
          <span className="label" />
          <span className="value">{item.productGroup}</span>
        </div>
      </div>
    )
  }
}
